/** Resolves the localized quick-add placeholder for plan and battlefield surfaces. */
import { useMemo } from 'react';
import { useT } from '@/i18n/useT';
import {
  dropQuickbarPlaceholderTokens,
  parseQuickbarPlaceholder,
  quickbarPlaceholderDropCount,
} from '@/i18n/quickbarPlaceholder';
import { useBreakpoint } from '@/hooks/ui/useBreakpoint';

/**
 * Responsive quickbar placeholder: full text on xl desktop; drops longest tokens on narrower viewports.
 * @param {{ narrowField?: boolean }} [options]
 */
export function useQuickbarPlaceholder(options = {}) {
  const { narrowField = false } = options;
  const t = useT();
  const breakpoint = useBreakpoint();
  const full = t('quickbar.placeholder');

  return useMemo(() => {
    const { tokens } = parseQuickbarPlaceholder(full);
    const dropCount = Math.min(
      quickbarPlaceholderDropCount(breakpoint, { narrowField }),
      tokens.length,
    );
    return dropQuickbarPlaceholderTokens(full, dropCount);
  }, [breakpoint, full, narrowField]);
}
